import { Button, Grid, Divider } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2.5),
    borderRadius: 10,
    backgroundColor: '#FFF',
    width: '100%',
  },
  infoCandidat: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  avatar: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    marginRight: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      width: 40,
      height: 40,
    },
  },
  divStudent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5),
  },
  address: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    width: '50%',
    '@media (max-width: 430px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  duoTextIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  skeletonColor: {
    backgroundColor: '#D6E7FF !important',
    '&::after': {
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
    },
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: theme.spacing(1),
    display: 'inline-block',
  },
  sectionSpacing: {
    marginTop: theme.spacing(2.5),
  },
  hideInfosSection: {
    width: '100%',
    marginTop: theme.spacing(2),
  },
}));

const CandidatsCardSkeleton = ({ hideInfos = false, hideAbsence = false }) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} md={4} lg={3} style={{ padding: '20px 20px 0 0' }}>
      <div>
        <div className={classes.card}>
          <div>
            <div>
              {/* Header avec avatar + nom + actions */}
              <div className={classes.infoCandidat}>
                <div>
                  <Skeleton variant="circle" width={56} height={56} className={classes.avatar + ' ' + classes.skeletonColor} />
                </div>
                <div style={{
                  marginLeft: 12,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  width: '100%'
                }}>
                  <div className={classes.divStudent}>
                    <Skeleton variant="text" width="65%" height={24} className={classes.skeletonColor} />
                    {/* <Skeleton variant="rect" width={32} height={32} className={classes.skeletonColor} style={{ borderRadius: 8 }} /> */}
                  </div>
                  <div className={classes.address} style={{ marginTop: 0 }}>
                    <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor} />
                    <Skeleton variant="text" width="50%" height={18} className={classes.skeletonColor} style={{ marginLeft: 8 }} />
                  </div>
                </div>
              </div>
            </div>

            <div>
              {/* Section hideInfos conditionnelle */}
              {hideInfos && (
                <div className={classes.hideInfosSection}>
                  {/* Âge */}
                  <div className={classes.address + ' ' + classes.duoTextIcon}>
                    <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
                    <Skeleton variant="text" width="30%" height={18} className={classes.skeletonColor} />
                  </div>
                  {/* Email */}
                  <div className={classes.address + ' ' + classes.duoTextIcon}>
                    <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
                    <Skeleton variant="text" width="70%" height={18} className={classes.skeletonColor} />
                  </div>
                  {/* Téléphone */}
                  <div className={classes.address + ' ' + classes.duoTextIcon}>
                    <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
                    <Skeleton variant="text" width="45%" height={18} className={classes.skeletonColor} />
                  </div>
                </div>
              )}

              {/* Absence - seulement si pas caché */}
              {!hideAbsence && (
                <div className={classes.address + ' ' + classes.duoTextIcon}>
                  <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
                  <Skeleton variant="text" width="60%" height={18} className={classes.skeletonColor} />
                </div>
              )}

              {/* Section hideInfos conditionnelle - Classe et Formation */}
              {!hideInfos && (
                <>
                  <div className={classes.address + ' ' + classes.duoTextIcon} style={{ marginTop: 20 }}>
                    <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
                    <Skeleton variant="text" width="55%" height={18} className={classes.skeletonColor} />
                  </div>
                  {/* Training component skeleton */}
                  <div className={classes.address + ' ' + classes.duoTextIcon}>
                    <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
                    <Skeleton variant="text" width="65%" height={18} className={classes.skeletonColor} />
                  </div>
                </>
              )}

              {/* Entreprise */}
              <div className={classes.address + ' ' + classes.duoTextIcon}>
                <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
                <Skeleton variant="text" width="70%" height={18} className={classes.skeletonColor} />
              </div>

              {/* AffiliateInfo Grid */}
              <div className={classes.address + ' ' + classes.duoTextIcon} style={{ marginTop: 20 }}>
                <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
                <Skeleton variant="text" width="40%" height={18} className={classes.skeletonColor} />
              </div>

              {/* Bouton "Voir les détails" */}
              <div style={{ marginTop: 20 }}>
                <Skeleton variant="rect" width="100%" height={40} className={classes.skeletonColor} style={{ borderRadius: 4 }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Grid>
  );
};

export default CandidatsCardSkeleton; 